import CompositeFormField from './composite-field.js';
export default class EmploymentHistory extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);
        this.minYears = Number(this.el.dataset.minYears);
        this.minMonths = Number(this.minYears) * 12;
        this.employment0Container = el.querySelector('.employment0Container');
        this.employment0 = this.field('employment0');
        this.employment1Container = el.querySelector('.employment1Container');
        this.employment1 = this.field('employment1');
        this.bind();
    }

    bind() {
        this.form.addEventListener('onUpdate', (field) => this.onUpdate(field));
    }

    onUpdate(field) {
        if(this.el !== field.el && this.employment0Container.contains(field.el)) {
            this.showPreviousEmployments();
        }
    }

    showPreviousEmployments() {
        const isDisabledType = this.employment0.isDisabledType();
        const hasDuration = !this.empty(this.employment0.years) && !this.empty(this.employment0.months);
        if(isDisabledType) {
            this.employment1Container.classList.add('hide');
            this.employment1.disable();
        } else if(hasDuration) {
            const months = (Number(this.employment0.years.el.value) * 12) + Number(this.employment0.months.el.value);
            if(months >= this.minMonths) {                  
                this.employment1Container.classList.add('hide');
                this.employment1.disable();
            } else {
                this.employment1Container.classList.remove('hide');
                this.employment1.enable();
                this.employment1.checkJobType();
            }
        }
        
        this.update(this);
    }

    empty(input) {
        return input.el.value == null || input.el.value == '';
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_employment_history');
    }
}
